import React, { useEffect, useRef, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import './RichTextEditor.css';
import DrawingCanvas from './DrawingCanvas';
import { Button, Icon, Loader, Modal, Select, ConfirmationPopup, SuccessModal } from '@ohif/ui';
import { CreateNewTemplate, UpdatedReportData, UpdateReportTemplate, getCurrentReport } from '../Apis/apis';
import ImportHtml from './ImportHtml'
import AIFindings from './AIFindings';
import { _editorMode, _reportStatus, _roleType } from '@custom/Utils/constants/appConstants';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import discardReportApi from '@custom/rtk-apis/report/discardReport';
import { useLocation, useNavigate } from 'react-router-dom';
import { servicesManager } from '../../app/src/App';
import { debounce } from 'lodash';
import { useCallback } from 'react';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _commonUrls, _userUrls } from '@custom/Utils/constants/apiUrls';
import voiceService from '@custom/services/voiceService';
import io from 'socket.io-client';
import { baseURL } from '@custom/constant';
import { useTheme } from "../../ui/src/contextProviders"
import userDetails from '@custom/rtk-apis/user/userDetails';
import hospitalDetailApi from '@custom/rtk-apis/hospital/hospitalDetails';
import { Padding } from '@mui/icons-material';

interface RichTextEditorProps {
  selectedItem?: selectedItemType;
  retractable?: Boolean;
  setShowTextEditor?: Function;
  fetchReportTemplates?: Function;
  viewMode?: boolean;
  setViewMode?: Function;
  setSelectedTempleate?: Function
  setOpenReportPanel?: Function
  handleCreateReport?: Function
  setSelectedReport?: Function
  updateReportInformation?: Function
  mode?: string
  getReports?: Function
  setIsModalOpen?: Function,
  editorMode?: string | 'default'
  reportStatus?: string,
  reportId?: string,
  currentReportId?: string,
  from?: string
  setSelectedItem?: Function
  isPathology?: boolean
  patientId?: string;
  findingsProp?: string;
  commentprop?: string;
  impressionsProp?: string;
  updateFields?: any;
  onImpressionsChange?: any;
  impressions?: string;
  setImpressions?: any;
  editMode?: boolean;
  title?: string;
  rollbackStatus?: boolean;
  autoCreatedReportId?: string;
  setAutoCreatedReportId?: Function;
}

interface selectedItemType {
  createdOn: string
  modality: string
  templateHTML: string
  templateName: string,
  jsonData: object,
  editorMode: string,
  type: string
  _id: string
  _rev: string
  status?: string
  name?: string
  comment?: string
  impressions?: string
  templateId?: string;
  rollbackStatus?: boolean;
}

interface templatePayloadType {
  templateHTML: string,
  templateName: string,
  modality: {
    value: string,
    label: string
  }
}

interface LockInfo {
  userId: string;
  username: string;
  since: string;
}

interface ActiveUsers {
  [key: string]: LockInfo;
}

export const MediaSave = () => {
  return <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.0417 13.875V8.20833H3.95833V13.875M3.95833 1.125V4.66667H9.625M12.4583 13.875H2.54167C2.16594 13.875 1.80561 13.7257 1.53993 13.4601C1.27426 13.1944 1.125 12.8341 1.125 12.4583V2.54167C1.125 2.16594 1.27426 1.80561 1.53993 1.53993C1.80561 1.27426 2.16594 1.125 2.54167 1.125H10.3333L13.875 4.66667V12.4583C13.875 12.8341 13.7257 13.1944 13.4601 13.4601C13.1944 13.7257 12.8341 13.875 12.4583 13.875Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
}

const RichTextEditor: React.FC<RichTextEditorProps> = (props) => {
  const statusValue = (props.reportStatus || props.selectedItem?.status || '').trim();
  const isAuthorized = statusValue === 'Authorized';
  // Local state to control immediate visibility of Discard button after auto-save
  const [showDiscard, setShowDiscard] = useState<boolean>(false);
  const { uiNotificationService } = servicesManager.services
  let { editorMode } = props // Editor open in default, import
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const isDarkMode = useTheme();
  const isViewerPage = location.pathname === '/viewer';
  const { result } = useSelector((state: RootState) => state.discardReportResponse);
  const reportImageSelector = useSelector((state: RootState) => state.reportImageSelector)
  const aiImageSelector = useSelector((state: RootState) => state.aiImageSelector)
  const role = sessionStorage.getItem('role') || localStorage.getItem('role');
  const socketRef = useRef(null);
  const [activeUsers, setActiveUsers] = useState<ActiveUsers>({});
  const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  const userName = sessionStorage.getItem('name') || localStorage.getItem('name');
  const [modal, setModal] = useState(false);
  const [aiServiceAvailable, setAiServiceAvailable] = useState(false);
  const [createTemplatemodal, setCreateTemplateModal] = useState(false);
  const [editTemplatemodal, setEditTemplateModal] = useState(false);
  const [templateStatus, setTemplateStatus] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [savedImage, setSavedImage] = useState(null);
  const [selectedOption, setSelectedOption] = useState(props?.reportStatus ? props?.reportStatus : "Draft");
  const [_modalityOptions, setModalityOpton] = useState(null)

  const [saveTemplateErr, setSaveTemplateErr] = useState({
    templateNameErr: false,
    templateModalityErr: false
  });

  const [templateModal, setTemplateModal] = useState(false)
  const [templatePayload, setTemplatePayload] = useState<templatePayloadType>({
    templateHTML: '',
    templateName: '',
    modality: null
  })
  const [confirmation, setConfirmation] = useState(false)
  const [html, setHtml] = useState('')
  const [comment, setComment] = useState(props?.selectedItem ? props?.selectedItem?.comment : props.commentprop)
  const [findings, setFindings] = useState(props.findingsProp || '');
  const [impressions, setImpressions] = useState(props?.impressionsProp || props?.selectedItem?.impressions || '');
  const [addendum, setAddendum] = useState(props?.selectedItem?.addendum || '');
  const [aiFindings, setAiFindings] = useState(props?.selectedItem?.aiFindings || '');

  const fileInputRef = useRef(null);
  const htmlImportRef = useRef(null);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  useEffect(() => {
    if (props.reportStatus) {
      setSelectedOption(props.reportStatus);
    }
  }, [props.reportStatus]);

  useEffect(() => {
    setAddendum(props?.selectedItem?.addendum || '');
  }, [props?.selectedItem?.addendum]);

  const handleAddendumChange = (e) => {
    const newAddendum = e.target.value;
    setAddendum(newAddendum);
    if (snowRef.current) {
      const htmlString = snowRef.current.innerHTML;
      throttledUpdate(comment, htmlString, impressions, newAddendum, undefined);
    } else if (editorMode === _editorMode.import) {
      const htmlString = htmlImportRef.current.fetchInfo();
      throttledUpdate(comment, htmlString, impressions, newAddendum, undefined);
    }
  };

  const handleSaveOption = (e) => {
    setSelectedOption(e.target.value);
  };
  const openTemplateModal = () => {
    setSaveTemplateErr({
      templateNameErr: false,
      templateModalityErr: false
    });
    setTemplateModal(true)
  }
  const closeTemplateModal = () => setTemplateModal(false)

  const snowRef = useRef(null);
  const bubbleRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    if (props.setImpressions) {
      props.setImpressions(impressions);
    }
  }, [impressions]);

  useEffect(() => {
    setComment(props.commentprop || '');
    setFindings(props.findingsProp || '');
    setImpressions(props.impressionsProp || props?.selectedItem?.impressions || '');
    setAiFindings(props?.selectedItem?.aiFindings || '');
  }, [props.findingsProp, props.commentprop, props.impressionsProp, props?.selectedItem?.impressions, props?.selectedItem?.aiFindings])

  const handleSave = (dataURL) => {
    setSavedImage(dataURL);
    closeModal();
    // Insert the saved image into the Quill editor
    const quill = quillRef.current;
    const range = quill.getSelection();
    if (range) {
      quill.clipboard.dangerouslyPasteHTML(
        range.index,
        `<img src="${dataURL}" style="width: 10px; height: 10px;" class="resizable-image" />`
      );
    } else {
      quill.clipboard.dangerouslyPasteHTML(
        quill.getLength(),
        `<img src="${dataURL}" style="width: 10px; height: 10px;" class="resizable-image" />`
      );
    }
  };

  const processHTML = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.innerHTML;
  };

  const handleCreateTemplate = async () => {
    setTemplateModal(true);
    const htmlTemplate = snowRef.current;
    let result = { json: {}, html: null };

    if (editorMode === _editorMode.import) {
      result = htmlImportRef.current.fetchInfo();
    } else {
      result.html = htmlTemplate.outerHTML;
    }

    const payload = {
      templateName: templatePayload.templateName,
      templateHTML: result.html,
      modality: templatePayload.modality?.value,
      editorMode: editorMode,
      jsonData: result.json,
      findings: findings,
      impressions: impressions,
    };

    try {
      const response = await CreateNewTemplate(payload);
      console.log("Template created successfully", response);
      if (response?.status === 'SUCCESS') {
        setCreateTemplateModal(true);
        setTemplateStatus(true);
        setTimeout(() => {
          closeTemplateModal();
          props.setShowTextEditor(false);
          props.fetchReportTemplates();
        }, 1500);
      }
      else if(response?.status === 'FAILURE') {
        closeTemplateModal();
        uiNotificationService.show({
          title: "Error",
          message: response.msg,
          type: "error"
        });
      }
    } catch (err) {
      console.log('Error creating template:', err);
      uiNotificationService.show({
        title: "Error",
        message: "Failed to create template",
        type: "error"
      });
    }
  };

  const saveHandler = () => {
    const errState = {
      templateNameErr: false,
      templateModalityErr: false
    };
    if (templatePayload?.templateName == '' || templatePayload?.templateName == null) {
      errState.templateNameErr = true;
    }
    if (templatePayload?.modality?.value == '' || templatePayload?.modality?.value == null) {
      errState.templateModalityErr = true;
    }
    setSaveTemplateErr(errState);
    if (!errState.templateModalityErr && !errState.templateNameErr) {
      handleCreateTemplate()
    }
  }

  const handleImport = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        let html = e.target.result;
        const converted = processHTML(html)
        setHtml(converted)
      };
      reader.readAsText(file);
    }
  };

  useEffect(() => {
    if (props?.selectedItem) {
      setTimeout(() => {
        let newHtml = props?.selectedItem?.templateHTML;

        // Check the editor mode and update the content accordingly
        if (editorMode === _editorMode.import) {
          if(typeof newHtml === 'object' && newHtml?.html){
            const json = newHtml?.json;
            setHtml(newHtml?.html);
            setComment(props?.selectedItem?.comment)
          }else{
            setHtml(newHtml);
            setComment(props?.selectedItem?.comment)
          }
        } else {
          const quill = quillRef.current;
          if(typeof newHtml === 'object' && newHtml?.html){
            const json = newHtml?.json;
            quill.clipboard.dangerouslyPasteHTML(newHtml?.html || "", 'silent');
          }else{
            quill.clipboard.dangerouslyPasteHTML(newHtml || "", 'silent');
          }
        }
      }, 0); // Set a minimal delay
    }
  }, [props?.selectedItem, editorMode]);

  useEffect(() => {
    if (editorMode === _editorMode.import) return // No quill instance create

    let snow = new Quill(snowRef.current, {
      theme: 'snow',
      readOnly: isAuthorized,
      modules: {
        table: true,
        toolbar: isAuthorized ? false : [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          ['link', 'image'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ direction: 'rtl' }], // text direction

          [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],

          ['clean'], // remove formatting button
        ],
        clipboard: {
          matchVisual: false,
        },
        history: {
          delay: 500,
          maxStack: 100,
          userOnly: true,
        },
      },
    });
    if (isAuthorized) {
      snow.disable();
    }
    let bubble = new Quill(bubbleRef.current, {
      theme: 'bubble',
    });

    snow.on('text-change', function (delta, old, source) {
      if (source === 'user') {
        bubble.updateContents(delta, 'api');
        const htmlString = `${snowRef.current.innerHTML}`;
        const newComment = comment;
        if(typeof htmlString === 'object' && htmlString?.html){
          const json = htmlString?.json;
          throttledUpdate(newComment, htmlString?.html, impressions, addendum, undefined);
        }else{
          throttledUpdate(newComment, htmlString, impressions, addendum, undefined);
        }
      }
    });

    bubble.on('text-change', function (delta, old, source) {
      if (source === 'user') {
        snow.updateContents(delta, 'api');
      }
    });

    const tableModule = snow.getModule('table');

    const addClickListener = (selector, action) => {
      const element = document.querySelector(selector);
      if (!element) return;
      const listener = () => {
        action();
      };
      element.addEventListener('click', listener);
      return () => {
        element.removeEventListener('click', listener);
      };
    };

    let cleanUpFunctions = [];
    if (!props.retractable) {
      cleanUpFunctions = [
        addClickListener('#insert-table', () => tableModule.insertTable(2, 2)),
        addClickListener('#insert-row-above', () => tableModule.insertRowAbove()),
        addClickListener('#insert-row-below', () => tableModule.insertRowBelow()),
        addClickListener('#insert-column-left', () =>
          tableModule.insertColumnLeft()
        ),
        addClickListener('#insert-column-right', () =>
          tableModule.insertColumnRight()
        ),
        addClickListener('#delete-row', () => tableModule.deleteRow()),
        addClickListener('#delete-column', () => tableModule.deleteColumn()),
        addClickListener('#delete-table', () => tableModule.deleteTable()),
      ];
    }

    quillRef.current = snow;

    return () => {
      if (!props.retractable) {
        cleanUpFunctions.forEach((cleanUp) => cleanUp());
      }
      const toolbar = document.querySelector('.ql-toolbar');
      if (toolbar) {
        toolbar.remove();
      }
    }
  }, [props.selectedItem]);

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      if (commonData?.status) {
        setModalityOpton(commonData?.result?.modality)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchCommonData();
     const checkAiServiceAvailability = async () => {
          try {
            const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
            const [hospitalDetail, userDetail] = await Promise.all([
              dispatch(hospitalDetailApi({ hospitalId })).unwrap(),
              dispatch(userDetails()).unwrap()
            ]);
            setAiServiceAvailable(
              hospitalDetail?.result?.addOnsAvailable?.aiServices === true &&
              userDetail?.result?.aiTraining === true
            );
          } catch (err) {
            console.error("Error in checkAiServiceAvailability", err);
            setAiServiceAvailable(false);
          }
        };

        checkAiServiceAvailability();
  }, [])

  const validationErrorMsg = (errMsg) => <div className='text-red-600 text-xs'>
    {errMsg}
  </div>

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const editTemplateHandler = async (selectedItem) => {
    if (props.editorMode === 'import') {
      let result = { json: {}, html: null };
      result = htmlImportRef.current.fetchInfo();
      selectedItem.templateHTML = result.html;
      selectedItem.jsonData = result.json;
    } else {
      const htmlTemplate = snowRef.current;
      selectedItem.templateHTML = htmlTemplate.outerHTML;
    }

    selectedItem.findings = findings;
    selectedItem.impressions = impressions;

    try {
      const res = await UpdateReportTemplate(selectedItem);
      if (res?.status === 'SUCCESS') {
        setEditTemplateModal(true);
        setTemplateStatus(false);
        setTimeout(() => {
          props.setViewMode(false);
          props.fetchReportTemplates();
        }, 1500);
      }
    } catch (err) {
      console.error('Error updating template:', err);
    }
  };

  const handleSaveReport = (status, comment, updatedImpressions, buttonClick = false, newAddendum) => {
    const socketState = voiceService.getSocketState();

    if (socketState === WebSocket.OPEN) {
      voiceService.stopStreaming();
    } else if (socketState === WebSocket.CONNECTING) {
      voiceService.deleteStreaming();
    } else {
      voiceService.deleteStreaming();
    }

    if (props.handleCreateReport) {
      if (editorMode === _editorMode.import) {
        let result = { json: {}, html: null };
        result = htmlImportRef.current.fetchInfo();
        props.handleCreateReport(result?.html, status, comment, updatedImpressions, buttonClick, newAddendum)
      } else {
        props.handleCreateReport(snowRef?.current?.outerHTML, status, comment, updatedImpressions, buttonClick, newAddendum)
      }
    }
  }

  const handleDiscardReport = async () => {
    const getURL = window.location.href;
    const lastPart = getURL.split('/').pop();
    setIsLoading(true);
    setIsModalOpen(false);
    try {
      const result = await dispatch(discardReportApi(props.reportId || props?.currentReportId || props.autoCreatedReportId)).unwrap();
      if (result?.status === 'SUCCESS') {
        setIsModalOpen(false);
        if (props?.isPathology && window.history.length > 1) {
          navigate(-1);
        } else if (role === 'Pathologist') {
          navigate('/lab-studies');
        } else {
          if(lastPart === 'createReport'){
            navigate('/appointments');
          } else {
            navigate('/');
          }
        }
      } else {
        console.log('Failed to discard report:', result.error);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setIsLoading(false);
      setIsModalOpen(false);
    }
  };

  const handleOpenModal = () => {
    const socketState = voiceService.getSocketState();

    if (socketState === WebSocket.OPEN) {
      voiceService.stopStreaming();
    } else if (socketState === WebSocket.CONNECTING) {
      voiceService.deleteStreaming();
    } else {
      voiceService.deleteStreaming();
    }

    setIsModalOpen(true);
  };

  const handleChangeStatus = async (comment?) => {
    setIsLoading(true);
    const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
    let statusData = props.selectedItem;
    if (!props.editMode) {
      // statusData.status = statusData.status == _reportStatus.Draft ? statusData.status = _reportStatus.Completed
      //   : statusData.status == _reportStatus.Completed ? statusData.status = _reportStatus.Authorized : _reportStatus.Draft
      switch (statusData.status) {
        case _reportStatus.Draft:
          if (props?.title === 'Complete Report') {
            statusData.status = _reportStatus.Completed;
          } else if (props?.title === 'Authorize Report') {
            statusData.status = _reportStatus.Authorized;
          }
          break;

        case _reportStatus.SentForReview:
          if (props?.title === 'Complete Report') {
            statusData.status = _reportStatus.Completed;
          } else if (props?.title === 'Authorize Report') {
            statusData.status = _reportStatus.Authorized;
          }
          break;

        case _reportStatus.Completed:
          if (props?.title === 'Authorize Report') {
            statusData.status = _reportStatus.Authorized;
          }
          break;

        default:
          // No change for other statuses
          break;
      }

    }
    let result = { json: {}, html: null };
    if (editorMode === _editorMode.import) {
      result = htmlImportRef.current.fetchInfo();
    } else {
      result.html = snowRef.current.outerHTML
    }

    const commentId = document.getElementById('comment');
    const impressionId = document.getElementById('impression');
    const addendumId = document.getElementById('addendum');

    const payload = {
      templateHTML: result.html,
      _id: props.selectedItem?._id,
      status: props.selectedItem?.status,
      comment: commentId?.value || comment,
      impressions: impressionId?.value || impressions,
      addendum: addendumId?.value || addendum,
      aiFindings: aiFindings || props.selectedItem?.aiFindings,
      templateId: props.selectedItem?.templateId,
    }
    if (props.editMode) {
      payload['status'] = '';
    }
    try {
      const response = await UpdatedReportData(payload)
      if (response.res.ok) {
        setIsLoading(false);
        setModal(true)
        setTimeout(() => {
          setConfirmation(false)
          props.getReports()
          props.setIsModalOpen(false)
        }, 1500)
      }
      else {
        uiNotificationService.show({
          title: '',
          message:
            response?.msg || "Error occured",
          type: 'error',
        });
        setConfirmation(false)
        props.setIsModalOpen(false)
        props.getReports()
        if (role === _roleType.pathologist || role === 'Radiologist' || role === 'Technician' || role === _roleType.radiologistAdmin) {
          navigate(`/user/details/${userId}`);
        } else if (role === 'hospitalsuperadmin') {
          navigate('/edithospital');
        } else {
          navigate('/userProfile');
        }
      }
    } catch (err) {
      console.log('Error', err)
    }
  }

  const handleConfirmation = (comment) => {
    if (!props.editMode && props.selectedItem?.status == 'Completed') {
      setConfirmation(true)
    }
    else {
      handleChangeStatus(comment)
    }
    const socketState = voiceService.getSocketState();

    if (socketState === WebSocket.OPEN) {
      voiceService.stopStreaming();
    } else if (socketState === WebSocket.CONNECTING) {
      voiceService.deleteStreaming();
    } else {
      voiceService.deleteStreaming();
    }

  }

  const handleCancel = () => {
    props.getReports?.()
    if (props.setOpenReportPanel) {
      props.setOpenReportPanel(false);
    } else if (props.setIsModalOpen) {
      props.setIsModalOpen(false)
    }
    const socketState = voiceService.getSocketState();

    if (socketState === WebSocket.OPEN) {
      voiceService.stopStreaming();
    } else if (socketState === WebSocket.CONNECTING) {
      voiceService.deleteStreaming();
    } else {
      voiceService.deleteStreaming();
    }

  }

  const reportIdRef = useRef(props.reportId || props.currentReportId);
  useEffect(() => {
    reportIdRef.current = props.reportId || props.currentReportId || props.autoCreatedReportId;
    if (reportIdRef.current && !showDiscard) {
      // If parent passes reportId later, ensure the button becomes visible
      setShowDiscard(true);
    }
  }, [props.reportId, props.currentReportId, props.autoCreatedReportId, showDiscard]);

  // Keep latest props in refs to avoid stale closures inside debounce
  const selectedItemRef = useRef(props.selectedItem);
  useEffect(() => {
    selectedItemRef.current = props.selectedItem;
  }, [props.selectedItem]);

  const handleCreateReportRef = useRef(props.handleCreateReport);
  useEffect(() => {
    handleCreateReportRef.current = props.handleCreateReport;
  }, [props.handleCreateReport]);

  // Throttled update created only once
  const throttledUpdateRef = useRef<(...args: any[]) => void>();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isRunningRef = useRef<boolean>(false);
  const pendingUpdateRef = useRef<any>(null);

  if (!throttledUpdateRef.current) {
    throttledUpdateRef.current = (newComment, htmlString, updatedImpressions, newAddendum, newAiFindings) => {
      // Store the latest values
      pendingUpdateRef.current = { newComment, htmlString, updatedImpressions, newAddendum, newAiFindings };

      // If already running, just update the pending values and return
      if (isRunningRef.current) {
        return;
      }

      // Start the 5-second timer
      isRunningRef.current = true;
      timeoutRef.current = setTimeout(async () => {
        await executeUpdate();

        // After execution, check if there are new pending updates
        if (pendingUpdateRef.current) {
          // Restart the cycle if there were updates during execution
          isRunningRef.current = false;
          throttledUpdateRef.current?.(
            pendingUpdateRef.current.newComment,
            pendingUpdateRef.current.htmlString,
            pendingUpdateRef.current.updatedImpressions,
            pendingUpdateRef.current.newAddendum,
            pendingUpdateRef.current.newAiFindings
          );
        } else {
          isRunningRef.current = false;
        }
      }, 5000);
    };
  }

  const executeUpdate = async () => {
    if (!pendingUpdateRef.current) return;

    const { newComment, htmlString, updatedImpressions, newAddendum, newAiFindings } = pendingUpdateRef.current;
    const currentReportId = reportIdRef.current;
    const selectedItem = selectedItemRef.current;
    const handleCreateReportFn = handleCreateReportRef.current;

    // Clear pending update before execution
    const currentUpdate = pendingUpdateRef.current;
    pendingUpdateRef.current = null;
    try {
      if (currentReportId) {
        const commentId = document.getElementById('comment');
        const impressionId = document.getElementById('impression');

        const payload = {
          templateHTML: htmlString?.html ? htmlString?.html : htmlString,
          _id: currentReportId || props.selectedItem?._id,
          status: props.selectedItem?.status,
          comment: commentId?.value || newComment,
          impressions: impressionId?.value || updatedImpressions,
          addendum: newAddendum,
          aiFindings: newAiFindings || aiFindings,
          templateId: props.selectedItem?.templateId,
        };

        const response = await UpdatedReportData(payload);
        if (response?.res?.ok) {
          setShowDiscard(true);
          // Check if setAutoCreatedReportId is a function before calling it
          if (typeof props.setAutoCreatedReportId === 'function') {
            props.setAutoCreatedReportId(response?.data?._id);
          }
          try {
            window.dispatchEvent(new CustomEvent('report-autosaved'));
          } catch (dispatchError) {
            console.error('Error dispatching report-autosaved event:', dispatchError);
          }
          uiNotificationService.show({
            title: 'Success',
            message: response?.msg || "Report updated successfully",
            type: 'success',
            duration: 3000,
            position: 'topRight',
          });
        }
      } else if (handleCreateReportFn) {
        await handleCreateReportFn(htmlString?.html ? htmlString?.html : htmlString, "Draft", newComment, updatedImpressions);
        setShowDiscard(true);
        try {
          window.dispatchEvent(new CustomEvent('report-autosaved'));
        } catch (dispatchError) {
          console.error('Error dispatching report-autosaved event:', dispatchError);
        }
      }
    } catch (error) {
      console.error('Error in auto-save:', error);
      uiNotificationService.show({
        title: 'Error',
        message: 'Failed to auto-save report',
        type: 'error',
        duration: 3000,
      });
    }
  };

  // Function to cancel the auto-save
  const cancelAutoSave = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    isRunningRef.current = false;
    pendingUpdateRef.current = null;

    console.log('Auto-save cancelled');
  }, []);

  // Wrapper to call the stable throttled function
  const throttledUpdate = useCallback((newComment: string, htmlString: any, updatedImpressions: string, newAddendum: string, newAiFindings?: string) => {
    throttledUpdateRef.current?.(newComment, htmlString, updatedImpressions, newAddendum, newAiFindings);
  }, []);

  const handleInputChangeFromChild = (event: Event) => {
    if (editorMode === _editorMode.import) {
      const htmlString = htmlImportRef?.current?.fetchInfo();
      if(typeof htmlString === 'object' && htmlString?.html){
        const json = htmlString?.json;
        throttledUpdate(comment, htmlString?.html, impressions, addendum, undefined);
      }else{
        throttledUpdate(comment, htmlString, impressions, addendum, undefined);
      }
    }
  };

  const handleCommentChange = (e) => {
    const newComment = e.target.value;
    setComment(newComment);
    if (snowRef.current) {
      const htmlString = snowRef.current.innerHTML;
      if(typeof htmlString === 'object' && htmlString?.html){
        const json = htmlString?.json;
        throttledUpdate(newComment, htmlString?.html, impressions, addendum, undefined);
      }else{
        throttledUpdate(newComment, htmlString, impressions, addendum, undefined);
      }
    } else if (editorMode === _editorMode.import) {
      const htmlString = htmlImportRef?.current?.fetchInfo();
      if(typeof htmlString === 'object' && htmlString?.html){
        const json = htmlString?.json;
        throttledUpdate(newComment, htmlString?.html, impressions, addendum, undefined);
      }else{
        throttledUpdate(newComment, htmlString, impressions, addendum, undefined);
      }
    }
  };

  const handleImpressionChange = (e) => {
    const newImpression = e.target.value;
    setImpressions(newImpression);
    if (props.onImpressionsChange) {
      props.onImpressionsChange(newImpression)
    }
    if (snowRef.current) {
      const htmlString = snowRef.current.innerHTML;
      if(typeof htmlString === 'object' && htmlString?.html){
        const json = htmlString?.json;
        throttledUpdate("", htmlString?.html, newImpression, addendum, undefined);
      }else{
        throttledUpdate("", htmlString, newImpression, addendum, undefined);
      }
    } else if (editorMode === _editorMode.import) {
      const htmlString = htmlImportRef?.current?.fetchInfo();
      if(typeof htmlString === 'object' && htmlString?.html){
        const json = htmlString?.json;
        throttledUpdate("", htmlString?.html, newImpression, addendum, undefined);
      }else{
        throttledUpdate("", htmlString, newImpression, addendum, undefined);
      }
    }
  };

  // Initialize socket connection
  useEffect(() => {
    socketRef.current = io(baseURL, {
      extraHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    socketRef.current.on('connect', () => {
      console.log('Connected to socket server');
      if (props.reportId) {
        socketRef.current.emit('lockReport', {
          reportId: props.reportId,
          userId,
          username: userName,
          since: new Date().toISOString()
        });
      }
    });

    socketRef.current.on('reportLocked', ({ reportId, activeUsers: newActiveUsers }) => {
      if (reportId === props.reportId) {
        setActiveUsers(newActiveUsers);
      }
    });

    // socketRef.current.on('reportLockFailed', ({ reportId, lockedBy: lockedUserId, lockedByUsername, lockedSince }) => {
    //   if (reportId === props.reportId) {
    //     setLockInfo({
    //       userId: lockedUserId,
    //       username: lockedByUsername,
    //       since: lockedSince
    //     });
    //   }
    // });

    socketRef.current.on('reportUnlocked', ({ reportId, activeUsers: newActiveUsers }) => {
      if (reportId === props.reportId) {
        setActiveUsers(newActiveUsers);
      }
    });

    return () => {
      if (props.reportId) {
        socketRef.current.emit('unlockReport', { reportId: props.reportId, userId });
      }
      socketRef.current.disconnect();
    };
  }, [props.reportId, userId, userName]);

  const otherActiveUsers = Object.values(activeUsers).filter(user => user.userId !== userId);

  const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);

    return date.toLocaleString('en-US', {
      dateStyle: 'medium',
      timeStyle: 'short',
      hour12: true,
    });
  };

  return (
    <>
      {otherActiveUsers.length > 0 &&
        <button className='custom-report-status-indicator'>Ongoing
          <span className='dot'></span>
        </button>
      }
      {otherActiveUsers.length > 0 && (
        <div
          style={{
            backgroundColor: '#FEF3C7',
            borderLeft: '4px solid #D97706',
            color: '#92400E',
            padding: '1rem',
            marginTop: '1rem',
          }}
        >
          <p style={{ fontWeight: 'bold' }}>This report is currently being viewed by:</p>
          {otherActiveUsers.map((user, index) => (
            <div key={user.userId} style={{ marginTop: index > 0 ? '0.5rem' : 0 }}>
              <p>Name: {user.username}</p>
              <p>Since: {formatDateTime(user.since)}</p>
            </div>
          ))}
        </div>
      )}

      <div className='relative' style={{ padding: '0 8px 20px 0' }}>
        <Modal
          closeButton={true}
          shouldCloseOnEsc={true}
          isOpen={modalIsOpen}
          title={'Drawing Canvas'}
          onClose={closeModal}
          children={<>

            <DrawingCanvas onSave={handleSave} /></>}
          shouldCloseOnOverlayClick={true}
          movable={true}
        />

        {!props.retractable && !isAuthorized && <div id='toolbar' className='mb-2'>
          {
            editorMode === _editorMode.import ?
              <div className='h-10'>
                <input ref={fileInputRef} style={{ display: 'none' }} onChange={handleImport} className='ml-2' type='file' />
                <Button startIcon={<MediaSave />} className='bg-[#51A196] hover:bg-[#51A196]' onClick={handleButtonClick}>
                  Choose Template
                </Button>
              </div> :
              <>
                <div>
                  <h3 className="text-xl font-semibold mb-2 font-sans">Findings</h3>
                </div>
                <button className='h-6 w-6 bg-white ml-2 my-2' onClick={openModal}> <svg fill={isDarkMode?.isDarkMode ? "#ffffff" : "#000000"} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M6,7A1,1,0,0,1,7,8v8a1,1,0,0,1-2,0V8A1,1,0,0,1,6,7Zm5.293,1.627L14.919,5H4A1,1,0,0,0,3,6V18a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V10a1,1,0,0,1,2,0v8a3,3,0,0,1-3,3H4a3,3,0,0,1-3-3V6A3,3,0,0,1,4,3H16.919l1.707-1.707a1.029,1.029,0,0,1,1.414,0L22.707,3.96a1,1,0,0,1,0,1.414l-7.334,7.333a1,1,0,0,1-.707.293H12a1,1,0,0,1-1-1V9.334A1,1,0,0,1,11.293,8.627ZM13,11h1.252l6.334-6.333L19.333,3.414,13,9.748Z"></path></g></svg>
                </button>
                <button
                  id="insert-table"
                  className='h-6 w-6 bg-white ml-2 my-2'
                >
                  <svg
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M40.15 5H7.85C6.27599 5 5 6.27599 5 7.85V40.15C5 41.7241 6.27599 43 7.85 43H40.15C41.7241 43 43 41.7241 43 40.15V7.85C43 6.27599 41.7241 5 40.15 5Z"
                        stroke={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                        stroke-width="4"
                      ></path>
                      <path
                        d="M17 5V43"
                        stroke={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                        stroke-width="4"
                        stroke-linecap="round"
                      ></path>
                      <path
                        d="M31 5V43"
                        stroke={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                        stroke-width="4"
                        stroke-linecap="round"
                      ></path>
                      <path
                        d="M5 17H43"
                        stroke={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                        stroke-width="4"
                        stroke-linecap="round"
                      ></path>
                      <path
                        d="M5 31H43"
                        stroke={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                        stroke-width="4"
                        stroke-linecap="round"
                      ></path>
                    </g>
                  </svg>
                </button>
                <button
                  id="insert-row-above"
                  className='h-6 w-6 bg-white ml-2 my-2'
                >
                  <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    fill={isDarkMode?.isDarkMode ? "#ffffff" : "#000000"}
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path fill="none" d="M0 0H24V24H0z"></path>
                        <path d="M20 13c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1v-6c0-.552.448-1 1-1h16zm-1 2H5v4h14v-4zM12 1c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm1 2h-2v1.999L9 5v2l2-.001V9h2V6.999L15 7V5l-2-.001V3z"></path>
                      </g>
                    </g>
                  </svg>
                </button>
                <button
                  id="insert-row-below"
                  className='h-6 w-6 bg-white ml-2 my-2'
                >
                  <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    fill={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path fill="none" d="M0 0H24V24H0z"></path>
                        <path d="M12 13c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm1 2h-2v1.999L9 17v2l2-.001V21h2v-2.001L15 19v-2l-2-.001V15zm7-12c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h16zM5 5v4h14V5H5z"></path>
                      </g>
                    </g>
                  </svg>
                </button>
                <button
                  id="insert-column-left"
                  className='h-6 w-6 bg-white ml-2 my-2'
                >
                  <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    fill={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path fill="none" d="M0 0H24V24H0z"></path>
                        <path d="M20 3c.552 0 1 .448 1 1v16c0 .552-.448 1-1 1h-6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h6zm-1 2h-4v14h4V5zM6 7c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm1 2H5v1.999L3 11v2l2-.001V15h2v-2.001L9 13v-2l-2-.001V9z"></path>
                      </g>
                    </g>
                  </svg>
                </button>
                <button
                  id="insert-column-right"
                  className='h-6 w-6 bg-white ml-2 my-2'
                >
                  <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    fill={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path fill="none" d="M0 0H24V24H0z"></path>
                        <path d="M10 3c.552 0 1 .448 1 1v16c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h6zM9 5H5v14h4V5zm9 2c2.761 0 5 2.239 5 5s-2.239 5-5 5-5-2.239-5-5 2.239-5 5-5zm1 2h-2v1.999L15 11v2l2-.001V15h2v-2.001L21 13v-2l-2-.001V9z"></path>
                      </g>
                    </g>
                  </svg>
                </button>
                <button
                  id="delete-row"
                  className='h-6 w-6 bg-white ml-2 my-2'
                >
                  <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    fill={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path fill="none" d="M0 0H24V24H0z"></path>
                        <path d="M20 5c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1 .628.835 1 1.874 1 3 0 2.761-2.239 5-5 5s-5-2.239-5-5c0-1.126.372-2.165 1-3H4c-.552 0-1-.448-1-1V6c0-.552.448-1 1-1h16zm-7 10v2h6v-2h-6zm6-8H5v4h14V7z"></path>
                      </g>
                    </g>
                  </svg>
                </button>
                <button
                  id="delete-column"
                  className='h-6 w-6 bg-white ml-2 my-2'
                >
                  <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    fill={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path fill="none" d="M0 0H24V24H0z"></path>
                        <path d="M12 3c.552 0 1 .448 1 1v8c.835-.628 1.874-1 3-1 2.761 0 5 2.239 5 5s-2.239 5-5 5c-1.032 0-1.99-.313-2.787-.848L13 20c0 .552-.448 1-1 1H6c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h6zm-1 2H7v14h4V5zm8 10h-6v2h6v-2z"></path>
                      </g>
                    </g>
                  </svg>
                </button>
                <button
                  id="delete-table"
                  className='h-6 w-6 bg-white ml-2 my-2'
                >
                  <svg
                    viewBox="0 0 18 18"
                    xmlns="http://www.w3.org/2000/svg"
                    fill={isDarkMode?.isDarkMode ? '#ffffff' : "#000000"}
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        fill={isDarkMode?.isDarkMode ? '#ffffff' : "#494c4e"}
                        d="M17 0H1C.4 0 0 .5 0 1v16c0 .6.5 1 1 1h8c.6 0 1-.5 1-1v-2c0-2.8 2.2-5 5-5h2c.6 0 1-.5 1-1V1c0-.6-.4-1-1-1zM4 16H2v-2h2v2zm0-4H2v-2h2v2zm0-4H2V6h2v2zm0-4H2V2h2v2zm4 12H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V6h2v2zm0-4H6V2h2v2zm4 4h-2V6h2v2zm0-4h-2V2h2v2zm4 4h-2V6h2v2zm0-4h-2V2h2v2z"
                      ></path>
                      <path
                        fill={isDarkMode?.isDarkMode ? '#ffffff' : "#494c4e"}
                        d="M18 15c0 .6-.5 1-1 1h-4c-.6 0-1-.5-1-1s.5-1 1-1h4c.6 0 1 .4 1 1z"
                      ></path>
                    </g>
                  </svg>
                </button>

              </>
          }
        </div >
        }

        {
          editorMode === _editorMode.import ? <ImportHtml ref={htmlImportRef} html={html} isEditable={!isAuthorized} onInputChange={handleInputChangeFromChild} /> :
            <>
              <div
                id="snow-container"
                ref={snowRef}
                style={{ height: 'auto', minHeight: '500px', marginBottom: '20px', padding: "5px", overflowY: 'scroll' }}
              ></div>
              {props.selectedItem?.rollbackStatus && (
                <div>
                  <h3 className="text-xl font-semibold mb-2 font-sans">Addendum</h3>
                  <textarea
                    id="addendum"
                    className="w-full p-2 border border-gray-400 rounded bg-transparent"
                    rows={4}
                    value={addendum}
                    onChange={handleAddendumChange}
                  ></textarea>
                </div>
              )}
              <div>
                <h3 className="text-xl font-semibold mb-2 font-sans">Impression</h3>
                <textarea
                  id='impression'
                  className="w-full p-2 border border-gray-400 rounded bg-transparent"
                  rows={4}
                  value={impressions}
                  readOnly={isAuthorized}
                  onChange={isAuthorized ? undefined : handleImpressionChange}
                ></textarea>
              </div>
              <div
                id="bubble-container"
                ref={bubbleRef}
                style={{ height: '300px', marginBottom: '10px', display: 'none' }}
              >
              </div>
            </>
        }

        <div className='my-3 flex items-center justify-start gap-3'>
          {!props.retractable && !props.viewMode ?
            <Button startIcon={<MediaSave />} className='bg-[#51A196] hover:bg-[#51A196]' onClick={openTemplateModal}>
              Save
            </Button> :
            props.viewMode && <Button startIcon={<MediaSave />} className='bg-[#51A196] hover:bg-[#51A196]' onClick={() => editTemplateHandler(props.selectedItem)}>
              Update
            </Button>
          }
        </div>

        <CustomModal
          closeButton={true}
          shouldCloseOnEsc={true}
          isOpen={templateModal}
          title={'Create Template'}
          onClose={closeTemplateModal}
          shouldCloseOnOverlayClick={true}
          containerDimensions='35vw, auto'
        >
          <RenderModalHtml setTemplatePayload={setTemplatePayload} templatePayload={templatePayload} saveTemplateErr={saveTemplateErr} validationErrorMsg={validationErrorMsg} _modalityOptions={_modalityOptions} closeTemplateModal={closeTemplateModal} saveHandler={saveHandler} />
        </CustomModal>

        {props.from === 'template' ? null : ((selectedOption === "Draft" || selectedOption === "Completed" || props?.reportStatus === 'Sent for Review') && (
          <div className="mb-4">
            <label htmlFor="comment" className="block font-bold mb-2">Comment (For internal use only)</label>
            <textarea
              id="comment"
              rows={3}
              cols={100}
              value={comment || props?.selectedItem?.comment}
              readOnly={isAuthorized}
              onChange={isAuthorized ? undefined : handleCommentChange}

              className={`w-full p-2 border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent ${isDarkMode?.isDarkMode ? 'text-white' : 'text-black'}`}
            ></textarea>
            {/* {
               aiServiceAvailable &&
               (
                <AIFindings
                initialValue={props?.selectedItem?.aiFindings}
                isAuthorized={isAuthorized}
                editorMode={editorMode}
                htmlImportRef={htmlImportRef}
                snowRef={snowRef}
                comment={comment}
                impressions={impressions}
                addendum={addendum}
                throttledUpdate={throttledUpdate}
                selectedItem={props?.selectedItem}
                setAiFindings={setAiFindings}
                aiFindings={aiFindings}
                />)
           } */}
          </div>
        ))}

        {!(role === _roleType.pathologist || role === _roleType.technician || !isViewerPage) &&
          <div className='font-bold text-sm'>
            Selected Images: {reportImageSelector?.selectedImages?.length}
          </div>
        }

        {
          !props.setShowTextEditor && !props.viewMode && !props.mode && <>
            {props?.reportStatus !== 'Authorized' && props?.reportStatus !== 'Sent for Review' && <div className='saveAsOption'>
              <div>Save as :</div>
              <div className="form__radio__option mb_0">
                <input type="radio" name="saveOption"
                  value="Draft"
                  checked={selectedOption === "Draft"}
                  onChange={handleSaveOption}
                  className="form__radio__input" />
                <label className="form__radio__label draft-btn" htmlFor="saveOption">Draft</label>
              </div>
              <div className="form__radio__option mb_0">
                <input type="radio" name="saveOption"
                  value="Completed"
                  checked={selectedOption === "Completed"}
                  onChange={handleSaveOption}
                  className="form__radio__input" />
                <label className="form__radio__label complete-btn" htmlFor="saveOption">Complete</label>
              </div>
              {['Superadmin', 'Admin', 'Radiologist', 'Clinician', 'hospitalsuperadmin', 'teraradiologysuperadmin', _roleType.pathologist].includes(role) ? (
                <div className="form__radio__option mb_0">
                  <input
                    type="radio"
                    name="saveOption"
                    value="Authorized"
                    checked={selectedOption === "Authorized"}
                    onChange={handleSaveOption}
                    className="form__radio__input"
                  />
                  <label className="form__radio__label authorized-btn" htmlFor="saveOption">Authorize</label>
                </div>
              ) : <></>}
            </div>
            }
            <Button
              className="cancel-btn text-black border border-black mr-2 mt-2"
              onClick={() => {
                props.setOpenReportPanel(false);
                const socketState = voiceService.getSocketState();

                if (socketState === WebSocket.OPEN) {
                  voiceService.stopStreaming();
                } else if (socketState === WebSocket.CONNECTING) {
                  voiceService.deleteStreaming();
                } else {
                  voiceService.deleteStreaming();
                }
              }}
            >
              Cancel
            </Button>
            {!isAuthorized && props?.reportStatus !== 'Sent for Review' && <Button onClick={() => handleSaveReport(selectedOption, comment, impressions, true)}>
              Save
            </Button>
            }
            {(showDiscard && !isAuthorized && props.reportStatus !== 'Sent for Review') && (
              <button className="discard-btn ml-2 text-white" onClick={handleOpenModal}>
                Discard
              </button>
            )}
            {isModalOpen && (
              <ConfirmationPopup
                title={""}
                isOpen={isModalOpen}
                message={`Are you sure you want to discard this report?`}
                onConfirm={handleDiscardReport}
                onCancel={handleCancel}
              />
            )}
          </>
        }

        {
          props.mode && props.mode === 'ChangeStatus' &&
          <div className='flex justify-start gap-2 mt-2'>
            <Button
              className="bg-[#fff] text-white border border-black hover:bg-[#fff] mr-2"
              onClick={() => {
                handleCancel()
              }}
            >
              Cancel
            </Button>
            <Button className='bg-[#51A196] hover:bg-[#51A196]' onClick={() => handleConfirmation(comment)}>
              {props.editMode ? 'Update' : props.selectedItem.status === 'Completed' ? 'Authorize' : 'Save'}
            </Button>
            <button className="discard-btn ml-2 text-white" onClick={handleOpenModal}>
              Discard
            </button>
            {isModalOpen && (
              <ConfirmationPopup
                title={""}
                isOpen={isModalOpen}
                message={`Are you sure you want to discard this report?`}
                onConfirm={handleDiscardReport}
                onCancel={handleCancel}
              />
            )}
          </div>
        }
      </div >
      {modal &&
        <SuccessModal
          isSuccessModalOpen={modal}
          title="Report updated successfully."
          handleCloseModal={() => setModal(false)}
        />
      }
      {createTemplatemodal &&
        <SuccessModal
          isSuccessModalOpen={createTemplatemodal}
          title={'Template created successfully.'}
          handleCloseModal={() => setCreateTemplateModal(false)}
        />
      }
      {editTemplatemodal &&
        <SuccessModal
          isSuccessModalOpen={editTemplatemodal}
          title={'Template updated successfully.'}
          handleCloseModal={() => setEditTemplateModal(false)}
        />
      }
      {props.selectedItem?.status == 'Completed' && confirmation && <ConfirmationPopup
        title={""}
        isOpen={confirmation}
        message={`Are you sure you want Authorize this report?`}
        onConfirm={() => handleChangeStatus(comment)}
        onCancel={handleCancel}
      />}
      <Loader
        isLoaderOpen={isLoading}
        title={"Loading"}
      />
    </>
  );
};

export const SuccessModalConfrim = ({ handleCloseModal, title }) => {
  setTimeout(() => {
    handleCloseModal();
  }, 1500)
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '250px',
          width: '400px', // Set a width for the modal
          textAlign: 'center',
          borderRadius: '32px',
          padding: '20px 10px 20px 10px',
          position: 'fixed', // Use fixed position to center it on the screen
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)', // Center the modal
          backgroundColor: 'white', // Add background color to the modal
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', // Optional: add a shadow for better visibility
          zIndex: 1000, // Ensure the modal is above other elements
        }}
      >
        <Icon
          name="SuccessCircle"
          className="text-black cursor-pointer"
        />
        <p style={{
          fontFamily: 'Poppins, sans-serif',
          fontSize: '23.14px',
          fontWeight: 600,
          lineHeight: '34.71px',
          color: 'black',
          padding: '20px',
        }}>
          {title}
        </p>
      </div>
    </>
  )
}


export const ConfirmationModal = ({ setConfirmation, handleChangeStatus, title }) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '250px',
          width: '400px', // Set a width for the modal
          textAlign: 'center',
          borderRadius: '32px',
          padding: '20px 10px 20px 10px',
          position: 'fixed', // Use fixed position to center it on the screen
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)', // Center the modal
          backgroundColor: 'white', // Add background color to the modal
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', // Optional: add a shadow for better visibility
          zIndex: 1000, // Ensure the modal is above other elements
        }}
      >
        <p style={{
          fontFamily: 'Poppins, sans-serif',
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: '34.71px',
          color: 'black',
          padding: '20px',
        }}>
          {title}
        </p>
        <div>
          <Button className='mr-2' onClick={handleChangeStatus}>Yes</Button>
          <Button onClick={() => setConfirmation(false)}>No</Button>
        </div>
      </div>
    </>
  )
}

const RenderModalHtml = ({ setTemplatePayload, templatePayload, saveTemplateErr, validationErrorMsg, _modalityOptions, closeTemplateModal, saveHandler }) => {
  const modalityOptions = (_modalityOptions || []).map(option => ({
    value: option.value,
    label: option.value
  }));
  const role = sessionStorage.getItem('role') || localStorage.getItem('role');

  const handleChange = (e: any) => {
    const { name, value } = e.target.value
    setTemplatePayload({ ...templatePayload, [e.target.name]: e.target.value })
  }

  //Set modality to empty string if role is Pathology
  React.useEffect(() => {
    if (role === _roleType.pathologist) {
      setTemplatePayload((prev) => ({ ...prev, modality: { value: 'SM', label: 'SM' } }));
    }
  }, [role, setTemplatePayload]);

  return <div key="ui" className='flex items-start justify-center flex-col gap-2'>
    <div className='mb-2 flex flex-col items-start justify-center w-full'>
      <label className='text-black mb-2'>Template Name</label>
      <input value={templatePayload.templateName} className='w-full px-2 py-1 text-black border-1 border-[#CBCAD7]' name='templateName' placeholder='Enter name' type='text' onChange={handleChange} style={{ minHeight: "44px" }} />
    </div>
    {saveTemplateErr.templateNameErr && validationErrorMsg("Please enter a valid template name.")}
    {role != _roleType.pathologist &&
      <div className='mb-2 flex flex-col items-start justify-center w-full'>
        <label className='text-black mb-2'>Modality</label>
        <Select
          className="w-full"
          id="modality-wise"
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          isClearable={false}
          isDisabled={false}
          isSearchable={true}
          onChange={(value) => setTemplatePayload({ ...templatePayload, modality: value })}
          options={modalityOptions}
          placeholder="Modality Wise"
          value={templatePayload.modality}
        />
      </div>
    }
    {saveTemplateErr.templateModalityErr && validationErrorMsg("Please select a modality")}
    <div className='py-2 flex space-x-4'>
      <button className='border border-black text-gray-700 font-medium px-4 py-1 rounded-md hover:bg-gray-100' name='Cancel' onClick={closeTemplateModal}>Cancel</button>
      <Button className='bg-blue-600 text-white font-medium px-4 py-1 rounded-md hover:bg-blue-800 ml-3' name='Save' onClick={saveHandler}>Save</Button>
    </div>
  </div>
}

const CustomModal = ({
  closeButton = true,
  shouldCloseOnEsc = true,
  isOpen = false,
  title,
  onClose,
  children,
  shouldCloseOnOverlayClick = true,
  containerDimensions = '100vw, 100vh',
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (shouldCloseOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  const [width, height] = containerDimensions.split(',');

  return (
    <div
      className="createTemplateModal fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={handleOverlayClick}
    >
      <div
        className="relative bg-white p-6 rounded-lg shadow-lg"
        style={{ width: width.trim(), height: height.trim() }}
      >
        {closeButton && (
          <button
            className="absolute top-4 right-4 text-black text-3xl"
            onClick={onClose}
          >
            &times;
          </button>
        )}
        {title && <h2 className="text-xl font-bold mb-1">{title}</h2>}
        <hr />
        <div className="modal-content mt-4">
          {children}
        </div>
      </div>
    </div>
  );
};

export default RichTextEditor;
